import React from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

export default function AraciMerkezModul({
    id,
    title,
    icon: Icon,
    badge,
    open,
    onToggle,
    accent = "gold",
    children,
    className = "",
}) {
    const accents = {
        gold: "border-[#D4AF37]/25",
        violet: "border-violet-500/25",
        emerald: "border-emerald-500/25",
        amber: "border-amber-500/25",
        sky: "border-sky-500/25",
        rose: "border-rose-500/25",
    };

    if (!open) {
        return (
            <button
                type="button"
                onClick={onToggle}
                className={`w-full rounded-xl border border-white/10 bg-[#0B0F19]/40 px-4 py-3 flex items-center justify-between gap-3 text-left hover:bg-white/5 transition ${className}`}
            >
                <div className="flex items-center gap-2 min-w-0">
                    {Icon && <Icon className="h-4 w-4 text-slate-400 shrink-0" />}
                    <span className="text-sm font-medium text-slate-300 truncate">{title}</span>
                    {badge != null && badge > 0 && (
                        <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-rose-500/20 text-rose-300 border border-rose-500/30">
                            {badge}
                        </span>
                    )}
                </div>
                <ChevronDown className="h-4 w-4 text-slate-500 shrink-0" />
            </button>
        );
    }

    return (
        <section
            className={`rounded-xl border ${accents[accent] || accents.gold} bg-[#0B0F19]/50 overflow-hidden ${className}`}
            data-modul={id}
        >
            <button
                type="button"
                onClick={onToggle}
                className="w-full px-4 py-3 flex items-center justify-between gap-3 text-left hover:bg-white/5 transition border-b border-white/5"
            >
                <div className="flex items-center gap-2 min-w-0">
                    {Icon && <Icon className="h-4 w-4 text-[#D4AF37] shrink-0" />}
                    <span className="text-sm font-semibold text-slate-100">{title}</span>
                    {badge != null && badge > 0 && (
                        <span className="text-[10px] font-bold px-1.5 py-0.5 rounded-full bg-rose-500/20 text-rose-300 border border-rose-500/30">
                            {badge}
                        </span>
                    )}
                </div>
                <ChevronUp className="h-4 w-4 text-slate-500 shrink-0" />
            </button>
            <div className="p-4">{children}</div>
        </section>
    );
}
